import { NutzerChip } from '@/components/ui/NutzerChip';
import type { BestellungErfasser } from '@/types/dashboard';

/**
 * Wer hat das erfasst? — Ein Bauteil für Tabelle UND Karte (#104, A33.2).
 *
 * WAS SICH GEÄNDERT HAT
 *   Hier stand ein 8-Pixel-Farbpunkt neben dem Kürzel. Am Telefon war er
 *   kaum zu sehen, und Farbe allein trägt ohnehin keine Auskunft (E40) —
 *   wer rot und grün nicht unterscheidet, sah einen grauen Fleck.
 *
 *   Den Punkt ersetzt jetzt der `NutzerChip`, den es für genau diese
 *   Frage längst gibt: an den Verlaufszeilen, am Kommunikations-Eintrag,
 *   im Nutzerwechsel. Er trägt dieselbe Farbe UND das gewählte
 *   Identitäts-Symbol — zwei Merkmale statt einem, und das zweite ist
 *   benennbar („die Feder"). Die Kontrastfrage ist dort in A14.4 gelöst
 *   und gemessen: gefüllte Fläche mit Symbol in Cream (schwächste
 *   Mitarbeiterfarbe 3,37:1, für Grafik genügen 3:1), ohne Symbol ein
 *   Ring mit den Initialen in Ink auf dem Grund (13,7:1).
 *
 * WARUM NICHT EIN ZWEITES BAUTEIL FÜR DIE KARTE
 *   Fallstrick 15: Was an zwei Orten getrennt gebaut wird, läuft
 *   auseinander. Tabelle und Karte rufen dieselbe Komponente; sie
 *   unterscheiden sich nur in der Größe, und die ist ein Parameter.
 *
 * DAS KÜRZEL STEHT EINMAL DA, NICHT ZWEIMAL
 *   Es ist die Angabe, die man vorliest und in eine Rückfrage tippt —
 *   und der einzige Träger, der ohne Farbsehen und ohne Symbolkenntnis
 *   auskommt. Es gehört also daneben.
 *
 *   Aber nur, wenn der Chip ein Symbol zeigt. Wer kein Symbol gewählt
 *   hat, trägt die Initialen IM Chip; daneben noch einmal dieselben zwei
 *   Buchstaben ergibt „PP PP". Genau so stand es bei der ersten Messung
 *   auf der Karte, und es sah aus wie ein Fehler, weil es einer war.
 */
export function ErfasserBadge({
  user,
  groesse = 'klein'
}: {
  user: BestellungErfasser;
  /** `klein` in Tabelle und Karte, größer nur, wo Identität das Thema ist. */
  groesse?: 'klein' | 'normal';
}) {
  return (
    <span className="inline-flex items-center gap-1.5 text-sm text-ink" title={user.name}>
      <NutzerChip
        farbe={user.farbe}
        symbol={user.symbol}
        kuerzel={user.kuerzel}
        name={user.name}
        groesse={groesse}
      />
      {user.symbol !== null && (
        <span className="font-medium tabular-nums">{user.kuerzel}</span>
      )}
    </span>
  );
}
